// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../services/app-tab-controller";
import "./../bindings/bao-toolbar2";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-date-time-box";
import "./../bindings/element";
import "./../bindings/visibility";
import "./../bindings/bao-tabs";
import "./instruction";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoMenu from "./../services/bao-menu";
import Guid from "./../factories/guid";
import baoRouter from "./../services/bao-router";
import BaoDialogViewModel from "./../factories/bao-dialog";
import InstructionHistoryViewModel from "./instruction-history";
import InstructionShiftbookDialog from "./dialogs/instruction-shiftbook-dialog";
import finitoService from "./../services/finito-service";
import InstructionViewModel from "../view-models/instruction";

class Briefing extends (InstructionViewModel as any) {
    InstructionAttendees = ko.observableArray([]);
    SelectedAttendees = ko.observableArray([]);
    InstructionText2 = ko.observable();
    SelectedBriefingBookId = ko.observable();
    BriefingBooks = ko.observableArray([]);
    TextModuleField = ko.observable();
    SelectedTextModule = ko.observable();
    showTextModuleDialog = () => { };
    Text2ModuleField = ko.observable();
    EditRecipientsPermissionKey = "BriefingReportCustomToolbarRecipientsEdit";
    HasRecipientsEditPermission = Bao.Session.HasPermission(this.EditRecipientsPermissionKey, window.FinitoApplicationId);
    SelectedText2Module = ko.observable();
    showText2ModuleDialog = () => { };
    openAttendeeSearcher = () => { };
    ShiftbookName = ko.observable();
    removeAllAttendees = () => {
        let def = $.Deferred();
        this.TabPage.IsLoading(true);
        this.TabPage.DirtyFlag(true);
        Bao.post("Briefing/RemoveAllAttendees", JSON.stringify({
            instructionId: this.InstructionId(),
            sessionTabId: this.SessionTabId()
        }), () => {
            this.getRecipients().then(() => {
                this.TabPage.IsLoading(false);
                def.resolve();
            });
        });
        return def.promise();
    };
    removeAllRecipients = () => {
        let def = $.Deferred();
        this.TabPage.IsLoading(true);
        this.TabPage.DirtyFlag(true);
        Bao.post("Briefing/RemoveAllRecipients", JSON.stringify({
            instructionId: this.InstructionId(),
            sessionTabId: this.SessionTabId()
        }), () => {
            this.getRecipients().then(() => {
                this.TabPage.IsLoading(false);
                def.resolve();
            });
        });
        return def.promise();
    };
    LinkItemToInfoFn: any;
    OpenedInShiftbook: boolean;
    AskIfReadAtClosing: any;

    constructor(tabPage: TabPage) {
        super(tabPage);
        this.dispose();
        this.subscribe(this.SelectedAttendees, () => {
            this.addAttendeesAndRecipients(true);
        });
        this.subscribe(this.SelectedRecipients, () => {
            this.addAttendeesAndRecipients(false);
        });
    }
    getBriefingAttachments = () => {
        return Bao.post("Briefing/GetAttachments", JSON.stringify({ sessionTabId: this.SessionTabId() }));
    };
    attachmentAdded = () => {
        this.TabPage.IsLoading(true);
        this.TabPage.DirtyFlag(true);
        this.getBriefingAttachments().done((data) => {
            ko.map.fromJS(data, this.InstructionAttachment);
            this.TabPage.IsLoading(false);
        });
    };
    removeAttachment = (attachment) => {
        if (!this.IsHistory()) {
            this.TabPage.IsLoading(true);
            this.TabPage.DirtyFlag(true);
            attachment.DeleteInRevision(this.Revision());
            Bao.post("Briefing/RemoveAttachment", JSON.stringify({
                sessionTabId: this.SessionTabId(),
                attachmentId: attachment.InstructionAttachmentId(),
                deleteInRevision: this.Revision()
            })).done(() => {
                this.TabPage.IsLoading(false);
            });
        }
    };
    formatSelectedRecipients = (selectedRecipients, areAttendees = null) => {
        if (selectedRecipients && selectedRecipients.length > 0) {
            return ko.utils.arrayMap(selectedRecipients, (srs: any) => {
                return {
                    UserId: srs.UserId,
                    RoleId: srs.RoleId,
                    ShiftbookId: srs.ShiftbookId ? srs.ShiftbookId : this.ShiftbookId(),
                    ShiftTypeId: srs.ShiftTypeId,
                    IsAttendee: areAttendees
                };
            });
        }
        return [];
    };
    addAttendeesAndRecipients = (isAttendee) => {
        let selectedAttendees = isAttendee ? this.SelectedAttendees() : this.InstructionAttendees();
        let selectedRecipients = isAttendee ? this.Instructionrecipients() : this.SelectedRecipients();
        let attendeesAndRecipients = this.formatSelectedRecipients(selectedAttendees, true).concat(this.formatSelectedRecipients(selectedRecipients));
        if (attendeesAndRecipients && attendeesAndRecipients.length > 0) {
            this.addRecipients(attendeesAndRecipients);
        }
    };
    getRecipients = () => {
        return Bao.post("Briefing/GetRecipients", JSON.stringify({
            instructionId: this.InstructionId(),
            sessionTabId: this.SessionTabId(),
            revision: this.Revision()
        }), (result) => {
            let attendees = result.filter(r => r.IsAttendee);
            let recipients = result.filter(r => !r.IsAttendee);
            this.InstructionAttendees(attendees);
            this.Instructionrecipients(recipients);
        });
    };
    addRecipients = (recipients) => {
        let def = $.Deferred();
        this.TabPage.IsLoading(true);
        this.TabPage.DirtyFlag(true);
        Bao.post('Briefing/AddRecipients', JSON.stringify({
            instructionId: this.InstructionId(),
            revision: this.Revision(),
            recipients: recipients,
            sessionTabId: this.SessionTabId()
        }), () => {
            this.getRecipients().then(() => {
                this.TabPage.IsLoading(false);
                def.resolve();
            });
        });
        return def.promise();
    };
    removeAttendee = (attendee) => {
        let def = $.Deferred();
        this.TabPage.IsLoading(true);
        this.TabPage.DirtyFlag(true);
        Bao.post("Briefing/RemoveRecipient", JSON.stringify({
            instructionRecipientId: ko.unwrap(attendee.InstructionRecipientId),
            sessionTabId: this.SessionTabId(),
            instructionId: this.InstructionId()
        }), () => {
            this.getRecipients().then(() => {
                this.TabPage.IsLoading(false);
                def.resolve();
            });
        });
        return def.promise();
    };
    removeRecipient = (recipient) => {
        let def = $.Deferred();
        this.TabPage.IsLoading(true);
        this.TabPage.DirtyFlag(true);
        Bao.post("Briefing/RemoveRecipient", JSON.stringify({
            instructionRecipientId: ko.unwrap(recipient.InstructionRecipientId),
            sessionTabId: this.SessionTabId(),
            instructionId: this.InstructionId()
        }), () => {
            this.getRecipients().then(() => {
                this.TabPage.IsLoading(false);
                def.resolve();
            });
        });
        return def.promise();
    };
    init = () => {
        this.TabPage.IsLoading(true);
        let def = $.Deferred();
        this.LinkItemToInfoFn = this.TabPage.UrlData().linkFn;
        this.InstructionId(baoRouter.getRouteValue('id', this.TabPage));
        let shiftbookIdFromUrl = baoRouter.getRouteValue('shiftbookid', this.TabPage);
        this.ShiftbookId(shiftbookIdFromUrl);
        this.get().then(() => {
            this.OpenedInShiftbook = shiftbookIdFromUrl != null && !this.IsNew();
            if (this.ShiftbookId() == null && this.IsNew()) {
                let shiftbookDialog = new InstructionShiftbookDialog(this.TabPage, "Briefing");
                shiftbookDialog.OpenDialog().
                    then((result: any) => {
                    if (result != null) {
                        this.ShiftbookId(result.ShiftbookId);
                        this.InitBriefing().then(() => { def.resolve(); });
                    }
                    else {
                        this.AppTabController.RemoveTab(this.TabPage);
                        def.reject();
                    }
                });
            }
            else {
                this.InitBriefing().then(() => { def.resolve(); });
            }
        });
        return def.promise();
    };
    InitBriefing = () => {
        this.TabPage.IsLoading(true);
        return $.when(this.getBriefingBooks().then(() => {
            return $.when(this.get().then(() => {
                if (this.ShiftbookId() != null) {
                    this.SelectedBriefingBookId(this.ShiftbookId());
                }
                else {
                    this.ShiftbookId(this.BriefingBooks()[0].ShiftbookId);
                    this.SelectedBriefingBookId(this.ShiftbookId());
                }
            }));
        }).then(() => {
            return $.when(this.InitPermissionsByShiftbookId(), this.getCategories());
        }));
    };
    loaded = () => {
        let def = $.Deferred();
        this.registerMenuClick();
        this.toggleButtons();
        this.setTabTitle();
        this.TabPage.IsLoading(false);
        this.Focus();
        this.TabPage.DirtyFlag.reset();
        // set dirty flag for saving the linked task
        if (this.InfoId() != null) {
            this.TabPage.DirtyFlag(true);
        }
        // set this letiable to keep track if user should be asked for marking instruction as 'read' when closing (set here after model was loaded)
        this.AskIfReadAtClosing = this.AskIfMarkAsReadWhenClosingInstruction();
        this.SelectedBriefingBookId.subscribe(() => {
            this.TabPage.IsLoading(true);
            this.ShiftbookId(this.SelectedBriefingBookId());
            this.getCategories().always(() => { this.TabPage.IsLoading(false); });
        });
        this.SelectedText2Module.subscribe((selectedText2Module: any) => {
            finitoService.InsertAtCursorPosition(this.Text2ModuleField(), selectedText2Module.Text);
        });
        this.SelectedTextModule.subscribe((selectedTextModule: any) => {
            finitoService.InsertAtCursorPosition(this.TextModuleField(), selectedTextModule.Text);
        })
        def.resolve();
        return def.promise();
    };
    getBriefingBooks = () => {
        return Bao.post('Shiftbook/GetBriefingBooksForCurrentUser').then((serverResult) => {
            if (serverResult.BooksForCurrentUser.some(element => element.ShiftbookId === this.ShiftbookId()) === false) {
                var assignedShiftbookToCurrentBriefing = {
                    ShiftbookId: this.ShiftbookId(),
                    Name: this.ShiftbookName()
                };
                this.BriefingBooks().push(assignedShiftbookToCurrentBriefing);
            }
            if (serverResult.BooksForCurrentUser.length > 0) {
                serverResult.BooksForCurrentUser.forEach(element => this.BriefingBooks.push(element))
            }
            else {
                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgUserHasNoAssignedBriefingBooks"), "info");
            }
        });
    };
    CompleteCheck = () => {
        return Bao.post('Briefing/Validate', JSON.stringify({
            instructionModel: ko.map.toJS(this, true)
        }));
    };
    BeforeClose = (fn) => {
        if (this.TabPage.DirtyFlag() && this.SaveAllowed() && !this.IsHistory() && !this.IsClosed()) {
            this.shouldSave().then((shouldSave) => {
                if (shouldSave === true) {
                    this.validate().then((isValid) => {
                        if (isValid) {
                            this.Save().then(() => {
                                this.clearSession().then(() => {
                                    fn();
                                });
                            });
                        }
                        else {
                            this.showValidationErrors();
                        }
                    });
                }
                else if (shouldSave === false) {
                    this.clearSession().then(() => {
                        fn();
                    });
                }
            });
        }
        else {
            // if briefing isn't read, ask the user if he wants to mark it as read
            if (this.AskIfReadAtClosing && this.canRead()) {
                this.readInstructionQuestionDialog().then((userMarksAsRead) => {
                    if (userMarksAsRead === true) {
                        this.readBriefing(true).then(() => {
                            this.clearSession().then(() => {
                                fn();
                            });
                        });
                    }
                    else if (userMarksAsRead === false) {
                        this.clearSession().then(() => {
                            fn();
                        });
                    }
                });
            }
            else {
                this.clearSession().then(() => {
                    fn();
                });
            }
        }
    };
    registerMenuClick = () => {
        BaoMenu.registerEvent((btn) => {
            if (this.TabPage != null && this.TabPage.IsActiveTab != null && this.TabPage.IsActiveTab() === true) {
                switch (btn.ActionKey()) {
                    case 'BriefingNew':
                        this["new"]();
                        break;
                    case 'BriefingSave':
                        if ((this.TabPage.DirtyFlag() || this.IsNew()) && this.SaveAllowed() && !this.IsHistory()) {
                            this.validate().then((isValid) => {
                                if (isValid) {
                                    this.Save();
                                }
                                else {
                                    this.showValidationErrors();
                                }
                            });
                        }
                        break;
                    case 'BriefingDelete':
                        this["delete"]();
                        break;
                    case 'BriefingRead':
                        this.read();
                        break;
                    case 'BriefingHistory':
                        this.history();
                        break;
                    case 'BriefingPrint':
                        this.BriefingPrint();
                        break;
                }
            }
        });
    };
    BriefingPrint() {
        this.TabPage.IsLoading(true);
        Bao.post("Briefing/Print", JSON.stringify({
            BriefingId: this.InstructionId()
        }), (result) => {
            this.TabPage.IsLoading(false);
            if (result.Result == true) {
                baoRouter.setHash("document/" + result.Message);
            }
            else {
                new BaoDialogViewModel(Bao.Session.ApplicationName, result.Message, "info");
            }
        });
    }
    ;
    toggleButtons = () => {
        if (this.IsHistory && this.IsClosed && this.IsNew) {
            let canSave = (!this.IsHistory() && this.SaveAllowed() && !this.IsClosed.peek());
            BaoMenu.permissionEnable({ ActionKey: 'BriefingSave', Enabled: canSave, Context: this.TabPage.Context() });
            BaoMenu.permissionEnable({ ActionKey: 'BriefingDelete', Enabled: !this.IsHistory() && !this.IsClosed.peek() && !this.IsNew() && !this.IsPublished.peek(), Context: this.TabPage.Context() });
            BaoMenu.permissionEnable({ ActionKey: 'BriefingRead', Enabled: this.canRead(), Context: this.TabPage.Context() });
            BaoMenu.permissionEnable({ ActionKey: 'BriefingHistory', Enabled: this.HasHistory() && !this.IsNew(), Context: this.TabPage.Context() });
        }
    };
    get = () => {
        let def = $.Deferred();
        this.clearSession().then(() => {
            Bao.post('Briefing/Get', JSON.stringify({
                instructionId: this.InstructionId(),
                shiftbookId: this.ShiftbookId(),
                openedInShiftbook: this.OpenedInShiftbook
            })).then((result) => {
                ko.map.fromJS(result, this, this.TabPage.DirtyFlag);
                if (result.IsNew) {
                    this.TabPage.ObjectId(result.InstructionId);
                }
                this.getRecipients().then(() => {
                    def.resolve();
                    this.TabPage.DirtyFlag.reset();
                });
            });
        });
        return def.promise();
    };
    read = () => {
        this.canClose().then((canClose) => {
            if (canClose) {
                this.readBriefingYesNoDialog();
            }
            else {
                this.shouldSave().then((shouldSave) => {
                    if (shouldSave === true) {
                        this.save().then(() => {
                            this.readBriefingYesNoDialog();
                        });
                    }
                    else if (shouldSave === false) {
                        this.readBriefingYesNoDialog();
                    }
                });
            }
        });
    };
    readBriefingYesNoDialog = () => {
        let dialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.BriefingReadQuestion), 'yesno');
        dialog.DialogResult.subscribe((shouldRead) => {
            this.readBriefing(shouldRead);
        });
    };
    readBriefing = (shouldRead) => {
        let deferred = $.Deferred();
        if (shouldRead) {
            this.TabPage.IsLoading(true);
            Bao.post('Briefing/Read', JSON.stringify({
                instructionIds: [this.InstructionId()],
                shiftbookId: this.OpenedInShiftbook ? this.ShiftbookId() : null
            })).then((read) => {
                this.TabPage.IsLoading(false);
                if (read > 0) {
                    this.showAlert(finitoService.MessageKeys.BriefingReadSuccessful);
                    this.TabPage.DirtyFlag(false);
                    this.dispose();
                    this.AskIfReadAtClosing = false;
                    this.AppTabController.RemoveTab(this.TabPage);
                    Bao.raiseEvent('briefings:refresh', {});
                }
                else {
                    this.showAlert(finitoService.MessageKeys.BriefingReadError, 'info');
                }
            });
        }
        return deferred.promise();
    };
    ["new"] = () => {
        let linkHash = 'briefing/' + Guid();
        baoRouter.setHash(linkHash);
    };
    Save = () => {
        let def = $.Deferred();
        if (this.TabPage.DirtyFlag()) {
            let briefingModel = ko.map.toJS(this, true);
            briefingModel.InstructionAttachment = ko.map.toJS(this.InstructionAttachment);
            this.TabPage.IsLoading(true);
            Bao.post("Briefing/Save", JSON.stringify({
                instructionModel: briefingModel
            })).then((saved) => {
                if (saved) {
                    let defs = [];
                    if (typeof this.SubTabsSaveFn !== "undefined" && this.SubTabsSaveFn != false) {
                        ko.utils.arrayForEach(this.SubTabsSaveFn, (saveFn) => {
                            if (typeof saveFn === "function") {
                                defs.push(saveFn());
                            }
                        });
                    }
                    var subTasksDeferreds = $.when.apply(this, defs);
                    this.showAlert(finitoService.MessageKeys.BriefingSaveSuccessful);
                    if (typeof this.LinkItemToInfoFn === "function") {
                        this.LinkItemToInfoFn(ko.unwrap(this.InstructionId));
                    }
                    this.TabPage.DirtyFlag(false);
                    this.get().then(() => {
                        this.TabPage.IsLoading(false);
                        this.TabPage.ObjectId(this.InstructionId());
                        this.updateHash(this.InstructionId());
                        this.toggleButtons();
                        this.setTabTitle();
                        subTasksDeferreds.done(() => {
                            def.resolve();
                        }).always(() => {
                            this.TabPage.DirtyFlag(false);
                        });
                    });
                }
                else {
                    this.showAlert(finitoService.MessageKeys.BriefingSaveError, 'info');
                    this.TabPage.IsLoading(false);
                    this.setTabTitle();
                    subTasksDeferreds.done(() => {
                        def.resolve();
                    });
                }
                Bao.raiseEvent('briefings:refresh', {});
            });
        }
        else {
            def.resolve();
        }
        return def.promise();
    };
    canRead = () => {
        return (!this.IsHistory.peek() && !this.IsClosed.peek() && !this.IsNew() && this.CanMarkRead() && !this.IsRead.peek()); // && this.IsInstructionValid()
    };
    ["delete"] = () => {
        let dialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.BriefingDeleteQuestion), 'yesno');
        dialog.DialogResult.subscribe((canDelete) => {
            if (canDelete) {
                this.TabPage.IsLoading(true);
                return Bao.post('Briefing/Delete', JSON.stringify({
                    instructionIds: [this.InstructionId()]
                })).then((deleted) => {
                    if (deleted > 0) {
                        this.showAlert(finitoService.MessageKeys.BriefingDeleteSuccessful);
                        this.TabPage.DirtyFlag(false);
                        this.dispose();
                        this.AppTabController.RemoveTab(this.TabPage);
                        Bao.raiseEvent('briefings:refresh', {});
                    }
                    else {
                        this.showAlert(finitoService.MessageKeys.BriefingDeleteError, 'info');
                    }
                    this.TabPage.IsLoading(false);
                });
            }
        });
    };
    getHistory = (historyItem) => {
        this.BeforeClose(() => {
            this.TabPage.IsLoading(true);
            this.TabPage.DirtyFlag(false);
            if (historyItem) {
                if (historyItem.IsNewestRevision()) {
                    this.get().then(() => {
                        this.toggleButtons();
                        this.setTabTitle();
                        this.TabPage.IsLoading(false);
                    });
                }
                else {
                    this.clearSession().then(() => {
                        Bao.post('Briefing/GetHistory', JSON.stringify({
                            instructionHistoryId: historyItem.InstructionHistoryId()
                        })).then((result) => {
                            ko.map.fromJS(result, this, this.TabPage.DirtyFlag);
                                                      this.getRecipients().then(() => {
                                this.toggleButtons();
                                this.setTabTitle();
                                this.TabPage.IsLoading(false);
                            });
                        });
                    });
                }
            }
        });
    };
    history = () => {
        Bao.get('Briefing/History', $.param({
            instructionId: this.InstructionId()
        })).then((html) => {
            let dialog = new BaoDialogViewModel(Bao.Session.GetMessage('msgHistory'));
            dialog.ViewModel(new InstructionHistoryViewModel(this.InstructionId(), (historyItem) => {
                this.getHistory(historyItem);
                dialog.Close();
            }));
            dialog.Template(html);
            dialog.Buttons([
                {
                    Title: Bao.Session.GetMessage("msgOk"),
                    Click: () => {
                        if (dialog.ViewModel().Selection()) {
                            this.getHistory(dialog.ViewModel().Selection()[0]);
                        }
                        dialog.Close();
                    },
                    Enabled: dialog.ViewModel().HasSelection,
                    IsDefault: ko.observable(false),
                    Focus: () => { }
                },
                {
                    Title: Bao.Session.GetMessage("msgCancel"),
                    Click: () => {
                        dialog.Close();
                    },
                    Enabled: ko.observable(true),
                    IsDefault: ko.observable(true),
                    Focus: () => { }
                }
            ]);
            dialog.ViewModel().initialize();
            dialog.Open();
        });
    };
    clearSession = () => {
        let sessionKeyRecipients = 'recipients' + this.InstructionId();
        return Bao.post('Briefing/ClearSession', JSON.stringify({
            sessionTabId: this.SessionTabId(),
            sessionKeyRecipients: sessionKeyRecipients
        }));
    };
}
export default Briefing;